import React, { useState } from "react";
import { baseUrl } from '../library/comoda';

interface Command { label: string; cmd: string; }

const commands: Command[] = [
  { label: "Wake Grandolo", cmd: "Wake Grandolo" },
  { label: "ifconfig", cmd: "ifconfig" },
 // { label: "List", cmd: "ls" },
];

export default function CommandButtons() {
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);

  const sendCommand = async (cmd: string): Promise<void> => {
    try {
      setLoading(true);
      const res = await fetch(`${baseUrl}comandi.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `cmd=${encodeURIComponent(cmd)}`,
      });
      const text = await res.text();
      setResponse(text);
    } catch (err) {
      setResponse("Errore di rete");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="box background altezzafissa" >
      <h1>Easy Command Launcher</h1>
      <div>
        {commands.map(({ label, cmd }) => (
          <button className='btn command'
            key={cmd} 
            onClick={() => sendCommand(cmd)}
            disabled={loading}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="conferma margini">
        {loading ? <p>Attendere...</p> : <pre className="scrollable-pre">{response? response:"Risultato.."}</pre>}
      </div>
    </div>
  );
}
